import React from 'react';
import type { ScoreTriple } from '../calculator/calculator';
import { BadgeBar } from './BadgeBar';
import { getUniversityKey, getUniversityName } from '../common';
import { getUniversityIconSrc } from '@/lib/utils/universityNames';

interface TitleBarProps {
  jupasId: string;
  programmeName: string;
  progData: any;
  instData: any;
  ger: any;
  per: any;
  translate: (key: any) => string;
  userScores?: Record<string, ScoreTriple>;
  activeSubjects?: string[];
  programmes: any[];
  className?: string;
  titleClassName?: string;
  logoClassName?: string;
}

export const TitleBar: React.FC<TitleBarProps> = ({
  jupasId,
  programmeName,
  progData,
  instData,
  ger,
  per,
  translate,
  userScores,
  activeSubjects,
  programmes,
  className,
  titleClassName,
  logoClassName
}) => {
  const titleClasses = titleClassName || 'text-white-600 text-base mr-3';
  const instKey = getUniversityKey(jupasId);
  const universityName = getUniversityName(jupasId);

  return (
    <div className={`flex items-start gap-3 flex-1 ${className || ''}`.trim()}>
      {/* University Logo */}
      <div className={`flex-shrink-0 rounded-lg flex items-center justify-center ${logoClassName || 'bg-white p-2 w-12 h-12'}`}>
        <img
          src={getUniversityIconSrc(instKey)}
          alt={universityName}
          title={universityName}
          className="w-full h-full object-contain"
          onError={(e) => { e.currentTarget.style.display = 'none'; }}
        />
      </div>

      <div className="flex-1 min-w-0">
        <div className="flex items-center gap-2 mb-1 flex-wrap">
          <span className={titleClasses}>
            JS{jupasId} - {programmeName}
          </span>
        </div>

        <BadgeBar
          prog_data={progData}
          inst_data={instData}
          ger={ger}
          per={per}
          translate={translate}
          userScores={userScores}
          activeSubjects={activeSubjects}
          programmes={programmes}
        />
      </div>
    </div>
  );
};
